<template>
  <div>
    <el-row>
      <!--现价-->
      <el-col :span="8">
        <el-form-item label="现价">
          <el-input v-model="certifications[index].amount" placeholder="请输入现价" />
        </el-form-item>
      </el-col>

      <!--原价-->
      <el-col :span="8">
        <el-form-item label="原价">
          <el-input v-model="certifications[index].originalPrice" placeholder="请输入原价" />
        </el-form-item>
      </el-col>

      <!--兑换积分-->
      <el-col :span="8">
        <el-form-item label="获得积分">
          <el-input v-model="certifications[index].integral" placeholder="购买商品获得积分" />
        </el-form-item>
      </el-col>

      <!--型号-->
      <el-col :span="8">
        <el-form-item label="型号">
          <el-input v-model="certifications[index].mode" placeholder="请输入型号" />
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="所需积分">
          <el-input v-model="certifications[index].score" placeholder="购买商品所需要的积分" />
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="型号图片">
          <thumbnail @getFiles="getMd5" :md5s="certifications[index].icon"></thumbnail>
        </el-form-item>
      </el-col>
    </el-row>

    <span v-if="certifications.length > 1 && minusStatus" @click="subtractBanner(index)" class="location_box el-icon-remove-outline" style="font-size: 20px;cursor: pointer"></span>
  </div>
</template>

<script>
import Thumbnail from '@/components/common/thumbnail/thumbnails'

export default {
  components: { Thumbnail },
  name: 'modelList',
  props: {
    certifications: {
      type: Array,
      default: null
    },
    index: {
      type: Number,
      default: 0
    },
    minusStatus: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {

    }
  },
  methods: {
    //删除一行banner
    subtractBanner(i) {
      if (this.certifications.length > 1) {
        this.certifications.splice(i,1)
      }
    },

    getMd5(md5) {
      this.certifications[this.index].icon = md5.md5
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .shuttle_bus {
  position: relative;
  .location_box {
    position: absolute;
    top: 8px;
    right: 10px;
  }
}
</style>
